export default [
  {
    path: "/",
    name: "default",
    meta: {
      title: "Ana Sayfa",
      authRequired: true,
      requiresParams: false,
    },
    component: () => import("@/views/AnaSayfa.vue"),
  },
  {
    path: "/ana-sayfa",
    name: "ana-sayfa",
    component: () => import("@/views/AnaSayfa.vue"),
    meta: {
      title: "Ana Sayfa",
      authRequired: true,
      requiresParams: false,
    },
  },
  {
    path: "/impersonate",
    name: "impersonate",
    component: () => import("@/views/Administration/ImpersoneteIslem.vue"),
    meta: {
      title: "Impersonate",
      authRequired: true,
      requiresParams: false,
    },
  },
  {
    path: "/tokenreader",
    name: "tokenreader",
    component: () => import("../views/TokenReader.vue"),
    meta: {
      title: "TokenReader",
      authRequired: false,
      requiresParams: false,
    },
  },
  {
    path: "/redirector",
    name: "redirector",
    component: () => import("../views/error/Redirector.vue"),
    meta: {
      title: "Redirector",
      authRequired: true,
      requiresParams: false,
    },
  },
  {
    path: "/route-page",
    name: "route-page",
    component: () => import("../views/RoutePage.vue"),
    meta: {
      title: "Yönlendirme Sayfası",
      authRequired: true,
      requiresParams: false,
    },
  },
  {
    path: "/ezio",
    name: "SoftwareDevelopmentLogin",
    component: () => import("@/views/EzioAuditore.vue"),
    meta: {
      title: "B&IT Girişi",
      requiresParams: true,
      authRequired: false,
      layout: "guest",
    },
  },
  {
    path: "/error-403",
    name: "error-403",
    component: () => import("../views/error/Error403.vue"),
    meta: {
      title: "403",
      requiresParams: false,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/error-500",
    name: "error-500",
    component: () => import("../views/error/Error500.vue"),
    meta: {
      title: "500",
      requiresParams: false,
      layout: "full",
    },
  },
  {
    path: "/public/rehber",
    name: "rehber",
    component: () => import("@/views/Rehber/Rehber.vue"),
    meta: {
      title: "Rehber",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/rehber-detail",
    name: "rehber-detail",
    component: () => import("@/views/Rehber/RehberDetail.vue"),
    meta: {
      title: "Rehber",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/belge-viewer",
    name: "BelgeViewer",
    component: () => import("@/views/BelgeViewer/BelgeViewer.vue"),
    meta: {
      title: "Belge Görüntüleyici",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/preview",
    name: "preview",
    component: () => import("@/views/Preview/PreviewMain.vue"),
    meta: {
      title: "Preview",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/preview/:programId",
    name: "previewWithParams",
    component: () => import("@/views/Preview/PreviewMain.vue"),
    meta: {
      title: "Preview",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/login",
    name: "LoginLanding",
    component: () => import("@/views/LoginLanding.vue"),
    meta: {
      title: "Giriş",
      requiresParams: false,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/guest-login",
    name: "GuestLogin",
    component: () => import("@/views/Guest/GuestLogin.vue"),
    meta: {
      title: "Misafir Girişi",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/guest-landing",
    name: "GuestLanding",
    component: () => import("@/views/Guest/GuestLanding.vue"),
    meta: {
      title: "Misafir Ana Sayfa",
      requiresParams: false,
      authRequired: false,
      layout: "guest",
    },
  },
  {
    path: "/login-callback",
    name: "GuestLoginCallback",
    component: () => import("@/views/LoginCallBack.vue"),
    meta: {
      title: "Misafir Giriş Yönlendirme Sayfası",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/ebm-referans-form/:p",
    name: "ebm-referans-form",
    component: () => import("@/views/EnstituBasvuruModulu/ReferansFormu.vue"),
    meta: {
      title: "Enstitü Başvuru Referans Formu",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/ikame-arac-qr-dogrulama/:p",
    name: "ikame-arac-qr-dogrulama",
    component: () => import("@/views/CarSticker/TempRequestQrVerification.vue"),
    meta: {
      title: "İkame Araç QR Doğrulama",
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
];
